import axios from "axios";

const NO_AUTH_ROUTE_AUTHORIZATION = "no-auth-route";

const create = (baseUrl: string) => {
  const axiosApi = axios.create({ baseURL: baseUrl });
  return axiosApi;
};

const createAxiosInstances = (baseUrl: string) => {
  // Creating axios instance for authenticated requests
  const axios = create(baseUrl);

  // Creating a noAuthAxios instance for no-authenticated requests (OAuth/Authorize and OAuth/Token requests)
  const noAuthAxios = create(baseUrl);

  noAuthAxios.interceptors.request.use((request) => {
    request.headers.Authorization = NO_AUTH_ROUTE_AUTHORIZATION;
    return request;
  });

  return { axios, noAuthAxios };
};

export default { createAxiosInstances };
